var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionButton',{attrs:{"title":_vm.$t('maintenance_detail.history'),"icon":"mdi-format-list-bulleted","action":_vm.goHistory}})
}
var staticRenderFns = []

export { render, staticRenderFns }